import React, { useContext, useState, useEffect } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, TextField, Checkbox, CircularProgress } from '@mui/material';
import DrawerContext from '../../../context/DrawerContext.js';

const VerifyAtModal = ({ modalDetails }) => {
  
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const drawerCtx = useContext(DrawerContext);

  console.log(modalDetails);

  const [removeNote, setRemoveNote] = useState(true);
  const [verifyMessage, setVerifyMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric',});

    setVerifyMessage(`Company has been verified on ${formattedDate}`);
  }, []);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleSave = async () => {
    if (!verifyMessage.trim() || !modalDetails.id) return;
    setLoading(true);

    Promise.all([
      removeNote ? fetch(
        `${process.env.REACT_APP_API_URI}/v3/admin/company/${modalDetails.id}/notes`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authCtx.token}`,
          },
          body: JSON.stringify({
            agentId: null,
            note: verifyMessage,
          }),
        }
      ) : Promise.resolve(),
      fetch(
        `${process.env.REACT_APP_API_URI}/v3/admin/company/${modalDetails.id}/verify`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      )
    ])
    .then(([noteResponse, verifyResponse]) => {
      if (verifyResponse.status !== 200) {
        throw new Error('Verification failed');
      }
      
      if (removeNote) {
        if (noteResponse.status !== 201) {
          throw new Error('Note creation failed');
        }
      }
      
      modalCtx.closeModal();
      modalCtx.setPageUpdate({ page: "Companies", companyId: modalDetails.id });
      setLoading(false);
    })
    .catch(err => {
      console.error('Error during verification:', err);
      setLoading(false);
    });
  };

  return (
    <div className="modal-container">
      <div className="modal-header">
        <h1>Verify Listing<br/><span className="company-name">{modalDetails.companyDetails.company}</span></h1>
      </div>

      <div className="modal-body create-container agent-modal">
        {removeNote && (
          <>
            <p>Add a note with the the verification?</p>
            <TextField fullWidth multiline rows={3} value={verifyMessage} onChange={(e) => setVerifyMessage(e.target.value)} />
          </>
        )}
        <div className="checkbox-container">
          <Checkbox checked={!removeNote} onChange={(e) => setRemoveNote(!e.target.checked)} />
          <span>Don't add a note with your verification</span>
        </div>
      </div>

      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}> Close </Button>
        <Button onClick={handleSave} disabled={loading}>{loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} Verify</Button>
      </div>
    </div>
  );
};

export default VerifyAtModal;
